module.exports = __webpack_public_path__ + "static/media/36f.9ebabe63.jpg";